export default "__VITE_ASSET__Cjwy8sdc__"